// Textos del personal: traducen los códigos de error del backend y las acciones de la auditoría.

const ERRORS = {
  email_already_registered: 'Ya existe una cuenta con ese correo.',
  invalid_email: 'Ingresá un correo válido (por ejemplo nombre@gmail.com).',
  invalid_name: 'Completá el nombre y el apellido (hasta 100 caracteres cada uno).',
  staff_not_found: 'Esa cuenta ya no existe. Actualizá la lista.',
  staff_inactive: 'La cuenta está desactivada: reactivala primero.',
  cannot_deactivate_self: 'No podés desactivar tu propia cuenta.',
  cannot_delete_self: 'No podés eliminar tu propia cuenta.',
  last_active_admin: 'No se puede: es el único administrador activo y el sistema no puede quedar sin ninguno.',
  password_too_short: 'La contraseña debe tener al menos 8 caracteres.',
  password_too_long: 'La contraseña es demasiado larga (máximo 72 caracteres).',
  invalid_token: 'El link no es válido.',
  expired_token: 'El link venció. Pedí que te envíen uno nuevo.',
  used_token: 'Este link ya se usó. Pedí que te envíen uno nuevo.',
  too_many_attempts: 'Demasiados intentos. Probá de nuevo en unos minutos.',
};

export const staffErrorText = (error, fallback = 'No se pudo completar la acción. Probá de nuevo.') => {
  if (error?.response?.status === 429) return ERRORS.too_many_attempts;
  const code = error?.response?.data?.error_message;
  return (code && ERRORS[code]) || fallback;
};

const ACTIONS = {
  STAFF_CREATED: 'Creó la cuenta',
  STAFF_UPDATED: 'Editó los datos',
  STAFF_DEACTIVATED: 'Desactivó la cuenta',
  STAFF_REACTIVATED: 'Reactivó la cuenta',
  STAFF_DELETED: 'Eliminó la cuenta',
  INVITE_SENT: 'Envió la invitación',
  RESET_SENT: 'Envió el restablecimiento de contraseña',
  PASSWORD_SET: 'Definió su contraseña',
};

export const auditActionText = (action) => ACTIONS[action] || action;

/** Estado visible de una cuenta: inactiva manda sobre pendiente. */
export const staffStatus = (staff) => {
  if (!staff.active) return { label: 'Desactivada', color: 'default' };
  if (staff.passwordPending) return { label: 'Pendiente', color: 'warning' };
  return { label: 'Activa', color: 'success' };
};

export const fullName = (staff) => `${(staff.firstName || '').trim()} ${(staff.lastName || '').trim()}`.trim();
